import { render, staticRenderFns } from "./pageok.vue?vue&type=template&id=05891675&scoped=true&"
import script from "./pageok.vue?vue&type=script&lang=js&"
export * from "./pageok.vue?vue&type=script&lang=js&"
import style0 from "./pageok.vue?vue&type=style&index=0&id=05891675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05891675",
  null
  
)

export default component.exports